export default __webpack_public_path__ + "66fbf9fec6eb0eb9c3558411312c1de0.svg";